export default __webpack_public_path__ + "static/media/1.0611dcf2.jpg";